/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import CssBaseline from '@material-ui/core/CssBaseline';

import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import Notifier from '../Layout/snackbar/Notifier';
import { Loading } from '../../helpers/utils';

import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';

const App = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    window.addEventListener('load', () => {
      setLoaded(true);
    });
  }, []);

  return (
    <Provider store={store}>
      <CssBaseline />
      <SnackbarProvider maxSnack={5}>
        <Notifier />
        <BrowserRouter>
          <ScrollToTop>
            <>
              {!loaded && (<Loading />)}
              <div>
                <Router />
              </div>
            </>
          </ScrollToTop>
        </BrowserRouter>
      </SnackbarProvider>
    </Provider>
  );
};

export default hot(module)(App);
